import { Modal } from 'ant-design-vue'

const VERSION_KEY = 'css_app_version'
const CHECK_INTERVAL = 5 * 60 * 1000

let updateModalVisible = false
let checkTimer = null

function isVersionCheckEnabled () {
  // 打包部署（测试环境、正式环境）均注入 APP_VERSION；本地 npm run dev 无此变量，不检测
  return !!process.env.APP_VERSION
}

function getVersionUrl () {
  const publicPath = process.env.BASE_URL || '/'
  const base = publicPath.endsWith('/') ? publicPath : publicPath + '/'
  return base + 'version.json?t=' + Date.now()
}

function showUpdateModal (remoteVersion) {
  updateModalVisible = true
  Modal.confirm({
    title: '发现新版本',
    content: '系统已更新，请刷新页面以获取最新功能。',
    okText: '立即刷新',
    cancelText: '稍后',
    onOk: () => {
      localStorage.setItem(VERSION_KEY, remoteVersion)
      window.location.reload()
    },
    onCancel: () => {
      updateModalVisible = false
    }
  })
}

function checkRemoteVersion () {
  if (!isVersionCheckEnabled()) {
    return
  }

  fetch(getVersionUrl(), { cache: 'no-store' })
    .then(function (res) {
      if (!res.ok) return null
      return res.json()
    })
    .then(function (data) {
      if (!data || !data.version) return

      const remoteVersion = String(data.version)
      const currentVersion = String(process.env.APP_VERSION)

      if (currentVersion === remoteVersion) {
        localStorage.setItem(VERSION_KEY, remoteVersion)
        return
      }

      if (!updateModalVisible) {
        showUpdateModal(remoteVersion)
      }
    })
    .catch(function () {})
}

export function startAppVersionCheck () {
  if (!isVersionCheckEnabled()) {
    return
  }

  checkRemoteVersion()

  checkTimer = setInterval(checkRemoteVersion, CHECK_INTERVAL)

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      checkRemoteVersion()
    }
  })
}

export function stopAppVersionCheck () {
  if (checkTimer) {
    clearInterval(checkTimer)
    checkTimer = null
  }
}



// WEBPACK FOOTER //
// ./src/utils/appVersionCheck.js